var Backbone, EmailFormCheckboxInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormCheckboxInputView = (function(superClass) {
  extend(EmailFormCheckboxInputView, superClass);

  function EmailFormCheckboxInputView() {
    return EmailFormCheckboxInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormCheckboxInputView.prototype.tagName = 'li';

  EmailFormCheckboxInputView.prototype.events = {
    'change .checkbox_input': 'validate'
  };

  EmailFormCheckboxInputView.prototype.initialize = function(options) {
    this.options = options || {};
    this.model = this.options.model;
    this.label = this.model.label;
    this.I18nScope = 'modules.support';
    this.elementID = ".checkbox_input";
    this.inputInvalidMsgID = ".inputInvalidMsgID";
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.template = this.options.template;
    return this.isInputCompulsory = this.model.required === true || this.model.required === "true";
  };

  EmailFormCheckboxInputView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash()));
  };

  EmailFormCheckboxInputView.prototype.toHash = function() {
    return {
      label: this.label,
      required: this.isInputCompulsory,
      counter: this.model.counter,
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      checkbox_input_template: true
    };
  };

  EmailFormCheckboxInputView.prototype.isInputGiven = function() {
    return this.isInputValid();
  };

  EmailFormCheckboxInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormCheckboxInputView.prototype.getInputInvalidHtmlElement = function() {
    return this.$el.find(this.inputInvalidMsgID);
  };

  EmailFormCheckboxInputView.prototype.readInput = function() {
    return _.first(this.getInputHtmlElement()).checked;
  };

  EmailFormCheckboxInputView.prototype.isInputValid = function() {
    if (this.isInputCompulsory) {
      return this.readInput();
    }
    return true;
  };

  EmailFormCheckboxInputView.prototype.validateInput = function() {
    var showInvalidInputMsg;
    showInvalidInputMsg = this.isInputCompulsory && !this.readInput();
    if (showInvalidInputMsg) {
      return this.getInputInvalidHtmlElement().css('display', 'block');
    } else {
      return this.getInputInvalidHtmlElement().css('display', 'none');
    }
  };

  EmailFormCheckboxInputView.prototype.validate = function() {
    this.validateInput();
    return this.options.validateEmailForm();
  };

  EmailFormCheckboxInputView.prototype.setCreditRefundBoxSelectedFlag = function(data) {
    if (window.evaluate(Groupon.Support.ContentModel.isRefundEligible && !this.isInputCompulsory)) {
      return data.credit_refund_check_box_selected = this.readInput();
    }
  };

  EmailFormCheckboxInputView.prototype.populateInput = function(data) {
    var inputData;
    inputData = this.readInput();
    this.setCreditRefundBoxSelectedFlag(data);
    return data.description += "\n\n " + this.label + " : " + inputData;
  };

  return EmailFormCheckboxInputView;

})(Backbone.View);

module.exports = EmailFormCheckboxInputView;

//# sourceMappingURL=data:application/json;base64,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
